import { ASSETS } from "../constants";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about-section" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t("about.eyebrow")}</p>
          <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-[1.05] text-white sm:text-5xl">
            {t("about.title1")}
            <br />
            <span className="text-gold-gradient">{t("about.title2")}</span>
          </h2>
          <p className="mt-7 text-lg font-medium text-slate-200">{t("about.p1")}</p>
          <p className="mt-4 text-base leading-relaxed text-slate-400">{t("about.p2")}</p>
          <p className="mt-4 text-base leading-relaxed text-slate-400">{t("about.p3")}</p>
          <div className="mt-8 border-t border-gold/15 pt-6">
            <p className="font-display text-xl font-bold tracking-[0.15em] text-white">A&amp;A MOTORS</p>
            <p className="mt-1 text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t("tagline")}</p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative pb-12 pe-8">
            <div className="absolute -inset-3 rounded-[2rem] border border-gold/15" aria-hidden="true" />
            <img
              src={ASSETS.rrInterior}
              alt="Rolls-Royce starlight headliner and bespoke leather interior — A&A MOTORS Dubai"
              loading="lazy"
              data-testid="about-image-interior"
              className="relative w-full rounded-[1.6rem] object-cover shadow-[0_40px_120px_-40px_rgba(212,175,55,0.25)]"
            />
            <img
              src={ASSETS.poster}
              alt="A&A MOTORS — all cars available in Dubai: luxury, sports, supercars and SUVs"
              loading="lazy"
              data-testid="about-image-poster"
              className="absolute -bottom-0 end-0 w-2/5 max-w-[220px] rounded-2xl border-4 border-[#08080A] object-cover shadow-2xl shadow-black/60"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
